import options from './backdrop.directive';

export default {
    selector: 'dtBackdrop',
    options
};



// WEBPACK FOOTER //
// ./app/common/backdrop/index.js